<template>
  <a
    :class="[$route.name === 'projects' ? 'new-projects-card' : 'new-products-card', 'm-card-element m-card-element-design-2 m-card-primary m-card-transition']"
    :href="$t('mFeedSectionEmpty.cardReference')"
    @click.prevent="$modal.showModal(modalBody)"
  >
    <div class="m-card-element-info-data">
      <img
        :alt="$t('mFeedSectionEmpty.cardReference')"
        src="@/assets/img/ds2.png"
      >
      <h5>
        {{ cardSubTitle }}
      </h5>
      <h2 class="m-card-element-design-2-name">
        {{ cardTitle }}
      </h2>
     </div>

    <div class="m-card-element-info-state">
      <span class="m-card-element-create-action">
        {{ $t('mFeedSectionEmpty.cardInfoButton') }}
      </span>
    </div>
  </a>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionEmpty',

  computed: {
    cardSubTitle () {
      return this.$route.name === 'projects'
        ? this.$t('mFeedSectionEmpty.cardSubTitle.projects')
        : this.$t('mFeedSectionEmpty.cardSubTitle.products')
    },

    cardTitle () {
      return this.$route.name === 'projects'
        ? this.$t('mFeedSectionEmpty.cardTitle.projects')
        : this.$t('mFeedSectionEmpty.cardTitle.products')
    },

    modalBody () {
      return this.$route.name === 'projects'
        ? 'MoleculeFeedProjectsContentModalCreate'
        : 'MoleculeFeedProductsContentModalCreate'
    }
  }
}
</script>
